<script setup>
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

  const layoutStore = useLayoutStore()
</script>

<template>
  <div class="color-mode-switcher">
    <button
      type="button"
      class="toggle-button"
      aria-label="Toggle Dark Mode"
      @click="layoutStore.toggleAppearance"
    >
      <i v-if="layoutStore.isDarkMode" class="pi pi-sun"></i>
      <i v-else class="pi pi-moon"></i>
    </button>
  </div>
</template>

<style lang="scss" scoped>
  .color-mode-switcher {
    display: inline-block;
  }

  .toggle-button {
    @include resetButton();
    @include focusRing();

    i {
      font-size: 1.25rem;
    }
  }
</style>
